import { Text, Heading } from "../../components";
import Footer from "components/Footer";
import Navbar from "components/Navbar";

export default function BetaVersion() {
  return (
    <>
      {/* Beta version section */}
      <div className="w-full bg-gray-300">
        <div className="relative h-auto bg-gray-300 py-24 md:py-12">
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>
          </div>

          <div className="flex justify-center bg-gray-300 py-16 md:py-12">
            <div className="container-xs flex flex-col items-center justify-center text-center md:px-5">
              <Heading size="headings" as="h2" className="text-[28px] font-semibold text-blue_gray-900">
              Thank you for joining our Beta version and helping us test our engine!
              </Heading>

              <Text size="textmd" as="p" className="text-[18px] font-normal leading-[150%] text-black-900 mt-6 text-justify">
              With our Beta version, you can upload portfolios, have our system cleanse the portfolio feed, run our risk engine, 
              and automatically generate an interactive dashboard. Now you are ready to drill down into the risk drivers of a 
              single portfolio or compare up to five different portfolios on-the-fly. 
              If your uploaded file contains illiquid assets, our team will contact you to schedule a deep dive follow-up. 
              
              </Text>

              
              <Heading size="headingmd" as="h3" className="text-[18px] font-semibold text-blue_gray-900 mt-8">
                Next Steps:
              </Heading>

              
              <ul className="text-[16px] font-normal text-black-900 mt-4 list-disc list-inside text-left">
                <li>Create a <a href="/createAccount" className="inline text-blue-600 underline">new account</a> with Tail Risk Global </li>
                <li>Download and sign a reciprocal 
                  <a href="/doc/NDA.docx" className="inline text-blue-600 underline" download="TRG_NDA.docx"> Non-disclosure Agreement</a></li>
                <li>Sign into your <a href="/dashboard" className="inline text-blue-600 underline"> account</a></li>
              </ul>

              <Heading size="headingmd" as="h3" className="text-[18px] font-semibold text-blue_gray-900 mt-8">
                Coming Soon:
              </Heading>
              <ul className="text-[16px] font-normal text-black-900 mt-4 list-disc list-inside text-left">
                <li>Risk factor drivers</li>
                <li>Stress testing</li>
                <li>Real-time data updates</li>
                <li>Mobile phone app</li>
              </ul>
              
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
}
